module.exports = __webpack_public_path__ + "img/bm8.ae87a6a0.png";